import type { CSSProperties } from 'react';

/**
 * Branded streak flame — a two-tone (espresso body + amber core) mark matching
 * the one drawn on the shareable accomplishment card (`lib/shareImage.ts`). Used
 * instead of the OS `🔥` emoji so the streak looks identical on every device.
 *
 * Paths are the same 24×24 cubics as the share card's `FLAME_BODY`/`FLAME_CORE`.
 * Colours are fixed to the brand espresso/amber (the hero card's warm gradient is
 * constant across light/dark, so no theme switch is needed).
 */
export function StreakFlame({
  size = '1.05rem',
  className,
  style,
}: {
  size?: string;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      style={style}
    >
      <path
        d="M12,2.4 C12.6,5.4 14.6,6.8 16.2,9 C17.4,10.7 18,12.7 18,14.8 C18,18.6 15.3,21 12,21 C8.7,21 6,18.6 6,14.8 C6,11.5 8.2,9.4 9.6,6.6 C10.4,5 11.6,4 12,2.4 Z"
        fill="#3a2415"
      />
      <path
        d="M12,12 C13.4,13.6 14.2,14.8 14.2,16.4 C14.2,18.1 13,19.2 11.6,19.2 C10.3,19.2 9.3,18.2 9.3,16.8 C9.3,15.2 10.8,14.2 12,12 Z"
        fill="#d98a2b"
      />
    </svg>
  );
}
